import { Component, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Subscription } from "rxjs"
import { BrowsingService } from "../../../services/browsing.service"
import { FacetingService } from "../../../services/faceting.service"
import { fadeInXY } from "../../../utils/animations"

@Component({
    selector: "app-filter-by-discipline",
    templateUrl: "./filter-by-discipline.component.html",
    styleUrls: ["./filter-by-discipline.component.scss"],
    animations: [fadeInXY],
    standalone: false,
})
export class FilterByDisciplineComponent implements OnInit, OnDestroy {
    public disciplines = []
    public selectedDiscipline: any = null
    public selectedDisciplineId: number = null
    private subscriptions: Subscription[] = []

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private facetingService: FacetingService
    ) {}

    public ngOnInit() {
        this.subscriptions.push(
            this.browsingService.getSubjectsTree().subscribe(
                (data: any) => {
                    this.disciplines = data
                    this.updateSelectedDiscipline()
                },
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )
        this.subscriptions.push(
            this.route.queryParams.subscribe(() => {
                const facets: string[] = this.facetingService.getSelectedFacets(this.route)
                this.selectedDisciplineId = null

                facets.forEach((facet: string) => {
                    if (facet.indexOf("subject") !== -1) {
                        this.selectedDisciplineId = +facet.split(":")[1]
                    }
                })
                this.updateSelectedDiscipline()
            })
        )
    }

    public updateSelectedDiscipline() {
        if (!this.selectedDisciplineId || this.disciplines.length === 0) {
            this.selectedDiscipline = null
        } else {
            this.selectedDiscipline =
                this.disciplines.find((item): boolean => item.id === this.selectedDisciplineId) ||
                null
        }
    }

    public changeDiscipline($event, discipline: any) {
        this.facetingService.addFilter(`subject:${discipline.id}`, this.route, true)
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe())
    }
}
